export default function(pageName, callback){
  if ('querySelector' in document && document.querySelector(pageName)) {
    callback();
  }
}
